import { useState } from "react";
import Tabs from "../../../../../../../library/tabs";
import { ConfigurationContentWrapper } from "../../styled";
import ContentConfiguration from "./content";
import PositionConfiguration from "./position";
import RotationConfiguration from "./rotation";
import AlignmentConfiguration from "./alignment";
import SizingConfiguration from "./sizing";
import FontSelectConfiguration from "./font-select";
import FontSizingConfiguration from "./font-sizing";
import FontDecorationConfiguration from "./font-decoration";
import BorderColorConfiguration from "./border-color";
import BorderWidthConfiguration from "./border-width";
import ColorConfiguration from "./color";
import BackgroundColorConfiguration from "./background-color";
import BackgroundRadiusConfiguration from "./background-radius";

const TextSettings = () => {
  const [activeTab, setActiveTab] = useState<string>("content");

  const SELECTIONS = [
    {
      id: 0,
      key: "content",
      title: "Endre tekst",
      ariaLabel: "Endre tekst",
      display: (
        <ConfigurationContentWrapper>
          <ContentConfiguration />
        </ConfigurationContentWrapper>
      ),
    },
    {
      id: 1,
      key: "positioning",
      title: "Posisjonering",
      ariaLabel: "Posisjonering",
      display: (
        <ConfigurationContentWrapper>
          <PositionConfiguration />
        </ConfigurationContentWrapper>
      ),
    },
    {
      id: 2,
      key: "rotation",
      title: "Rotering",
      ariaLabel: "Rotering",
      display: (
        <ConfigurationContentWrapper>
          <RotationConfiguration />
        </ConfigurationContentWrapper>
      ),
    },
    {
      id: 3,
      key: "alignment",
      title: "Tekstplassering",
      ariaLabel: "Tekstplassering",
      display: (
        <ConfigurationContentWrapper>
          <AlignmentConfiguration />
        </ConfigurationContentWrapper>
      ),
    },
    {
      id: 4,
      key: "size",
      title: "Dimensjoner",
      ariaLabel: "Dimensjoner",
      display: (
        <ConfigurationContentWrapper>
          <SizingConfiguration />
        </ConfigurationContentWrapper>
      ),
    },
    {
      id: 5,
      key: "font-select",
      title: "Skrifttype",
      ariaLabel: "Skrifttype",
      display: (
        <ConfigurationContentWrapper>
          <FontSelectConfiguration />
        </ConfigurationContentWrapper>
      ),
    },
    {
      id: 6,
      key: "font-size",
      title: "Skriftstørrelse",
      ariaLabel: "Skriftstørrelse",
      display: (
        <ConfigurationContentWrapper>
          <FontSizingConfiguration />
        </ConfigurationContentWrapper>
      ),
    },
    {
      id: 7,
      key: "font-decoration",
      title: "Skriftdekorasjon",
      ariaLabel: "Skriftdekorasjon",
      display: (
        <ConfigurationContentWrapper>
          <FontDecorationConfiguration />
        </ConfigurationContentWrapper>
      ),
    },
    {
      id: 8,
      key: "border-color",
      title: "Konturfarge",
      ariaLabel: "Konturfarge",
      display: (
        <ConfigurationContentWrapper>
          <BorderColorConfiguration />
        </ConfigurationContentWrapper>
      ),
    },
    {
      id: 9,
      key: "border-width",
      title: "Konturtykkelse",
      ariaLabel: "Konturtykkelse",
      display: (
        <ConfigurationContentWrapper>
          <BorderWidthConfiguration />
        </ConfigurationContentWrapper>
      ),
    },
    {
      id: 10,
      key: "color",
      title: "Farge",
      ariaLabel: "Farge",
      display: (
        <ConfigurationContentWrapper>
          <ColorConfiguration />
        </ConfigurationContentWrapper>
      ),
    },
    {
      id: 11,
      key: "background-color",
      title: "Bakgrunnsfarge",
      ariaLabel: "Bakgrunnfarge",
      display: (
        <ConfigurationContentWrapper>
          <BackgroundColorConfiguration />
        </ConfigurationContentWrapper>
      ),
    },
    {
      id: 11,
      key: "background-radius",
      title: "Bakgrunnsradius",
      ariaLabel: "Bakgrunnsradius",
      display: (
        <ConfigurationContentWrapper>
          <BackgroundRadiusConfiguration />
        </ConfigurationContentWrapper>
      ),
    },
  ];

  return (
    <Tabs
      activeTab={activeTab}
      setActiveTab={setActiveTab}
      selections={SELECTIONS}
    />
  );
};

export default TextSettings;
